import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhyManagersDelayDifficultConversations from './components/WhyManagersDelayDifficultConversations';
import WhatIsEffectiveFeedback from './components/WhatIsEffectiveFeedback';
import DifficultSituations from './components/DifficultSituations';
import SkillsAfterTraining from './components/SkillsAfterTraining';
import TypicalMistakes from './components/TypicalMistakes';
import HowTrainingGoes from './components/HowTrainingGoes';
import RealCases from './components/RealCases';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import SuitableFor from './components/SuitableFor';
import FormatsSection from './components/FormatsSection';
import AboutTrainer from './components/AboutTrainer';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import FinalCTA from './components/FinalCTA';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'process' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function FeedbackDifficultConversationsPage() {
  return (
    <>
      
      <SeoTitle title="Обратная связь и сложные разговоры | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyManagersDelayDifficultConversations />
        <WhatIsEffectiveFeedback />

        <div id="skills">
          <DifficultSituations />
        </div>

        <SkillsAfterTraining />
        <TypicalMistakes />

        <div id="process">
          <HowTrainingGoes />
        </div>

        <RealCases />
        <WhyProgramsWork />

        <div id="results">
          <CompanyResults />
        </div>

        <SuitableFor />
        <FormatsSection />
        <AboutTrainer />
        <FAQSection />
        <ReadNextSection />
        <FinalCTA />
        <Footer />
      </div>
    </>
  );
}